export const EVENT_SHOW_UPDATE_BANNER = 'SHOW_UPDATE_BANNER';
